import {Box, Typography} from '@mui/material'
import {ReactNode, FC} from 'react'

type ActionDetailsSectionProps = {
  title: string
  value?: string | ReactNode
  mb?: number
  'data-test-id'?: string
}

export const ActionDetailsSection: FC<ActionDetailsSectionProps> = ({
  title,
  value,
  mb = 3,
  'data-test-id': dataTestId
}) => (
  <Box mb={mb} data-test-id={dataTestId}>
    <Typography variant="caption">{title}</Typography>
    <Typography component={'div'} sx={() => ({fontWeight: 500})}>
      {value || '-'}
    </Typography>
  </Box>
)
